export default ngModule => {

  ngModule.factory('NIBApi', function ($http, $q) {

    class NIBApi {

      getPublicKey() {
        return $http.get('/nib/public-key').then(response => response.data);
      }

      encryptCCNumber(cardNumber) {
        return this.getPublicKey().then(({PublicKey}) => {
          const keyData = new Buffer(PublicKey, 'base64');
          const publicKey = new nodeRsa(keyData, 'pkcs1-public-der', {});
          const encryptedData = publicKey.encrypt(cardNumber, 'base64');
          return encryptedData;
        });
      }
    }

    return new NIBApi();
  });
};



// WEBPACK FOOTER //
// ./src/services/nib-service.js